import { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { PrimeIcons } from "primereact/api";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  labelTooltipArchivio,
  labelTooltipProgetti,
  labelTooltipReports,
  labelTooltipSettings,
  labelTooltipTopic,
  labelTooltipUsers,
} from "_constants";
import { OpenedReportIndicator } from ".";
import { setCheckOpenedReportLoadStatus } from "store/slicer/CheckOpenedReportSlice";

export const Sidebar = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userRole = useAppSelector((state) => state.profiloSlice.role);

  const location = useLocation();
  const path = location.pathname;

  const [sidebarButtonActive, setSidebarButtonActive] = useState(0);

  useEffect(() => {
    const pathToButtonIndex: any = {
      "/bo/dashboard-list-grid": 0,
      "/bo/sources": 1,
      "/bo/topics": 2,
      "/bo/users": 3,
      "/bo/reports": 4,
      "/bo/settings": 5,
    };
    const initialButtonIndex = pathToButtonIndex[path];
    if (initialButtonIndex !== undefined) {
      setSidebarButtonActive(initialButtonIndex);
    }
    return () => {
      dispatch(setCheckOpenedReportLoadStatus(true));
    };
  }, [dispatch, path]);

  const navigateTo = (path: string) => {
    navigate(path);
  };

  return (
    <div className="_sidebar">
      <div>
        <Button
          icon={PrimeIcons.TH_LARGE}
          tooltip={labelTooltipProgetti}
          onClick={() => {
            setSidebarButtonActive(0);
            navigateTo("/bo");
          }}
          className={`bg ${sidebarButtonActive === 0 ? "active" : ""}`}
        />
        {(userRole === "SUPERADMIN" ||
          userRole === "ADMIN" ||
          userRole === "EDITOR") && (
          <>
            <Button
              icon={PrimeIcons.FOLDER_OPEN}
              className={`bg margin-top-8 ${
                sidebarButtonActive === 1 ? "active" : ""
              }`}
              tooltip={labelTooltipArchivio}
              onClick={() => {
                setSidebarButtonActive(1);
                navigateTo("/bo/sources");
              }}
            />
            <Button
              icon={PrimeIcons.TAG}
              className={`bg margin-top-8 ${
                sidebarButtonActive === 2 ? "active" : ""
              }`}
              tooltip={labelTooltipTopic}
              onClick={() => {
                setSidebarButtonActive(2);
                navigateTo("/bo/topics");
              }}
            />
          </>
        )}
        {(userRole === "SUPERADMIN" || userRole === "ADMIN") && (
          <Button
            icon={PrimeIcons.USERS}
            className={`bg margin-top-8 ${
              sidebarButtonActive === 3 ? "active" : ""
            }`}
            tooltip={labelTooltipUsers}
            onClick={() => {
              setSidebarButtonActive(3);
              navigateTo("/bo/users");
            }}
          />
        )}
      </div>
      <div className="bottom-icon-container">
        {(userRole === "SUPERADMIN" ||
          userRole === "ADMIN" ||
          userRole === "EDITOR") && (
          <Button
            icon={PrimeIcons.INBOX}
            className={`bg custom-button-icon-sidebar ${
              sidebarButtonActive === 4 ? "active" : ""
            } box-shadow-none `}
            tooltip={labelTooltipReports}
            onClick={() => {
              setSidebarButtonActive(3);
              navigateTo("/bo/reports");
            }}
          >
            <OpenedReportIndicator />
          </Button>
        )}
        <Button
          icon={PrimeIcons.COG}
          className={`bg ${sidebarButtonActive === 5 ? "active" : ""}`}
          tooltip={labelTooltipSettings}
          onClick={() => {
            setSidebarButtonActive(4);
            navigateTo("/bo/settings");
          }}
        />
      </div>
    </div>
  );
};
